module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/performers/performers.component.scss
// module id = ./src/app/routes/performers/performers.component.scss
// module chunks = 9